<script>
import API from "../../../API";
import toaster from "../../common/toaster";

import DialogBody from "../../dialog/components/dialog-body.vue";
import DialogActionbar from "../../dialog/components/dialog-actionbar.vue";
import Loading from "../../common/loading.vue";
import DialogHeader from "../../dialog/components/dialog-header.vue";
import DialogBase from "../../dialog/components/dialog-base.vue";
import TextField from "../../common/text-field.vue";
import PropertyTable from "../../common/property-table.vue";

export default {
    name: "privilegegroup-dialog",
    components: {PropertyTable, TextField, DialogBase, DialogHeader, Loading, DialogActionbar, DialogBody},
    data() {
        const name = Lang.langGet('Name');
        const mustEnter = Lang.langGet('You must enter a ');

        return {
            showDialog: false,
            processing: false,
            invalid: true,
            name: '',
            id: undefined,
            availablePrivilegegroups: {},
            selectedPrivilegeIds: [],

            stringRule: [
                function (value) {
                    if (value) {
                        return true;
                    }

                    return mustEnter + name;
                }
            ]
        }
    },
    computed: {
        privilegegroupItems() {
            return Object.keys(this.availablePrivilegegroups).map(privilegegroupName => {
                const child = this.availablePrivilegegroups[privilegegroupName];

                const childKeys = Object.keys(child);
                const privileges = childKeys.map(privilegeName => {
                    const privilege = child[privilegeName];
                    const selected = this.selectedPrivilegeIds.some(id => id === privilege.id);
                    return {...privilege, selected, parentName: privilegegroupName};
                });

                const selected = childKeys.every(privilegeName => {
                    const privilege = child[privilegeName];
                    return this.selectedPrivilegeIds.some(id => id === privilege.id);
                })

                const someSelected = childKeys.some(privilegeName => {
                    const privilege = child[privilegeName];
                    return this.selectedPrivilegeIds.some(id => id === privilege.id);
                })

                return {name: _.startCase(privilegegroupName), children: privileges, selected, someSelected};
            });
        },
        translations() {
            return {
                placeholder: Lang.langGet('New privilege group name'),
                privilegeName: Lang.langGet('Privilege name'),
                addPrivilegegroup: Lang.langGet('Add new privilegegroup'),
                editPrivilegegroup: Lang.langGet('Edit privilegegroup'),
                name: Lang.langGet('Name'),
                addedSuccessfully: Lang.langGet('Privilege Group :name added successfully', {name: this.name})
            }
        },
    },
    watch: {
        name(newName) {
            this.invalid = !newName;
        }
    },
    methods: {
        show() { this.showDialog = true; },
        hide() { this.showDialog = false; },
        refreshList() {
            EaseEventBus.fire('reloadPrivilegegroupTable');
        },
        handleClose() { this.hide(); },
        handleChange(newName) {
            this.name = newName;
        },
        updateTemplateDependencies(privilegeId, exists) {
            const [operation, _privilegeName, specification] = privilegeId.split('-');
            if (exists) {
                if (operation === 'delete') {
                    this.removePrivilegeIfExists(`add-template`);
                }
                if (operation === 'edit' && specification === 'advanced') {
                    this.removePrivilegeIfExists(`add-template`);
                    this.removePrivilegeIfExists(`delete-template`);
                }
                if (operation === 'edit' && specification === 'basic') {
                    this.removePrivilegeIfExists(`add-template`);
                    this.removePrivilegeIfExists(`delete-template`);
                    this.removePrivilegeIfExists(`edit-template-advanced`);
                }
                if (operation === 'view') {
                    this.removePrivilegeIfExists(`add-template`);
                    this.removePrivilegeIfExists(`delete-template`);
                    this.removePrivilegeIfExists(`edit-template-advanced`);
                    this.removePrivilegeIfExists(`edit-template-basic`);
                }
            } else {
                if (operation === 'add') {
                    this.addPrivilegeIfDoesntExist(`delete-template`);
                    this.addPrivilegeIfDoesntExist(`edit-template-advanced`);
                    this.removePrivilegeIfExists(`edit-template-basic`);
                    this.addPrivilegeIfDoesntExist(`view-template`);
                }
                if (operation === 'delete') {
                    this.addPrivilegeIfDoesntExist(`view-template`);
                }
                if (operation === 'edit' && specification === 'basic') {
                    this.removePrivilegeIfExists(`edit-template-advanced`);
                    this.removePrivilegeIfExists(`add-template`);
                    this.addPrivilegeIfDoesntExist(`view-template`);
                }
                if (operation === 'edit' && specification === 'advanced') {
                    this.removePrivilegeIfExists(`edit-template-basic`);
                    this.addPrivilegeIfDoesntExist(`view-template`);
                }
            }

            this.togglePrivilegegroupsIds(privilegeId);
        },
        updatePublishDependencies(privilegeId, exists) {
            const [_privilegeName, operation] = privilegeId.split('-');
            if (exists) {
                if (operation === 'delete') {
                    this.removePrivilegeIfExists(`publish-add-layerelement`);
                }
                if (operation === 'edit') {
                    this.removePrivilegeIfExists(`publish-add-layerelement`);
                }
                if (operation === 'view') {
                    this.removePrivilegeIfExists(`publish-add-layerelement`);
                    this.removePrivilegeIfExists(`publish-approve-layerelement`);
                    this.removePrivilegeIfExists(`publish-delete-layerelement`);
                    this.removePrivilegeIfExists(`publish-edit-layerelement`);
                    this.removePrivilegeIfExists(`publish-setduration-layerelement`);
                }
            } else {
                if (operation === 'add') {
                    this.addPrivilegeIfDoesntExist(`publish-delete-layerelement`);
                    this.addPrivilegeIfDoesntExist(`publish-edit-layerelement`);
                    this.addPrivilegeIfDoesntExist(`publish-view`);
                }
                if (operation === 'approve') {
                    this.addPrivilegeIfDoesntExist(`publish-view`);
                }
                if (operation === 'delete') {
                    this.addPrivilegeIfDoesntExist(`publish-view`);
                }
                if (operation === 'edit') {
                    this.addPrivilegeIfDoesntExist(`publish-view`);
                }
                if (operation === 'setduration') {
                    this.addPrivilegeIfDoesntExist(`publish-view`);
                }
            }

            this.togglePrivilegegroupsIds(privilegeId);
        },
        updateDependencies(privilegeId) {
            const exists = this.selectedPrivilegeIds.some(id => id === privilegeId);

            const [operation, privilegeName] = privilegeId.split('-');

            if (privilegeId === 'project-admin-light') {
                this.removePrivilegeIfExists('project-admin');
            }

            if (privilegeId === 'project-admin') {
                this.removePrivilegeIfExists('project-admin-light');
            }

            if (privilegeName === 'template') {
                this.updateTemplateDependencies(privilegeId, exists);
                return;
            }

            // WTF why is operation and privilegeName changed for ONLY publish
            // "add-campaign" vs "publish-add"
            if (operation === 'publish') {
                this.updatePublishDependencies(privilegeId, exists);
                return;
            }

            if (exists) {
                if (operation === 'edit') {
                    this.removePrivilegeIfExists(`add-${privilegeName}`);
                    this.removePrivilegeIfExists(`delete-${privilegeName}`);
                }
                if (operation === 'delete') {
                    this.removePrivilegeIfExists(`add-${privilegeName}`);
                }
                if (operation === 'view') {
                    this.removePrivilegeIfExists(`add-${privilegeName}`);
                    this.removePrivilegeIfExists(`delete-${privilegeName}`);
                    this.removePrivilegeIfExists(`edit-${privilegeName}`);
                }
            } else {
                if (operation === 'add') {
                    this.addPrivilegeIfDoesntExist(`delete-${privilegeName}`);
                    this.addPrivilegeIfDoesntExist(`view-${privilegeName}`);
                    this.addPrivilegeIfDoesntExist(`edit-${privilegeName}`);
                }
                if (operation === 'delete') {
                    this.addPrivilegeIfDoesntExist(`view-${privilegeName}`);
                }
                if (operation === 'edit') {
                    this.addPrivilegeIfDoesntExist(`view-${privilegeName}`);
                }
            }

            this.togglePrivilegegroupsIds(privilegeId);
        },
        togglePrivilegegroupsIds(privilegeId) {
            const index = this.selectedPrivilegeIds.findIndex(id => id === privilegeId);
            if (index < 0) {
                this.selectedPrivilegeIds.push(privilegeId);
            } else {
                this.selectedPrivilegeIds.splice(index, 1);
            }
        },
        removePrivilegeIfExists(privilegeId) {
            const index = this.selectedPrivilegeIds.findIndex(id => id === privilegeId);
            if (index >= 0) {
                this.selectedPrivilegeIds.splice(index, 1);
            }
        },
        addPrivilegeIfDoesntExist(privilegeId) {
            const index = this.selectedPrivilegeIds.findIndex(id => id === privilegeId);
            if (index < 0) {
                this.selectedPrivilegeIds.push(privilegeId);
            }
        },
        handleChangePrivilege(item, isChild) {
            // console.log(`${isChild ? 'Change a children' : 'Change'}`, item);
            if (isChild) {
                this.updateDependencies(item.id);
                return;
            }

            if (item.selected) {
                if (item.name === 'Template') {
                    this.selectedPrivilegeIds.push('add-template');
                    this.selectedPrivilegeIds.push('delete-template');
                    this.selectedPrivilegeIds.push('edit-template-advanced');
                    this.selectedPrivilegeIds.push('view-template');

                    return;
                }

                if (item.name === 'Project Management') {
                    this.selectedPrivilegeIds.push('project-admin');
                    this.selectedPrivilegeIds.push('switch-off-times');

                    return;
                }

                item.children.forEach(child => {
                    this.selectedPrivilegeIds.push(child.id);
                });
                return;
            }

            this.selectedPrivilegeIds = this.selectedPrivilegeIds
                .filter(id => {
                    return !item.children.some(child => child.id === id);
                });
        },
        async handleSave() {
            this.processing = true;
            const url = this.id
                ? '/administration/privilegegroup/edit'
                : '/administration/privilegegroup/add';
            const api = new API(url);

            const data = {name: this.name, projectId: Laravel.activeProject, privileges: this.selectedPrivilegeIds};

            if (this.id) {
                data.id = this.id;
            }

            // console.log('Saving with', data);
            const result = await api.post(data);
            // console.log('Result', result);
            this.processing = false;

            if (result.errored) {
                this.errored = true;
            } else {
                this.errored = false;
                toaster.success(this.translations.addedSuccessfully);
                this.refreshList();
                this.hide();
            }
        },
        addSelectedPrivileges(result) {
            Object.keys(result).map(privilegegroupName => {
                const child = result[privilegegroupName];
                Object.keys(child).forEach(privilegeName => {
                    const privilege = child[privilegeName];
                    if (privilege.assigned) {
                        this.selectedPrivilegeIds.push(privilege.id);
                    }
                });
            });
        },
        async load() {
            this.processing = true;
            const url = '/administration/privilegegroup/edit/privilege';
            const api = new API(url);

            this.selectedPrivilegeIds = [];
            this.name = '';

            const result = await api.post({projectId: Laravel.activeProject, privilegegroup: this.id});
            this.processing = false;

            if (result.errored) {
                this.errored = true;
            } else {
                this.errored = false;

                this.name = result.name;
                delete result.name;

                this.addSelectedPrivileges(result);

                this.availablePrivilegegroups = result;
            }

            // console.log('Data loaded:', this.availablePrivilegegroups);
            // console.log('Items for table', this.privilegegroupItems);
        },
        calculateTitleAndButtonHeight() {
            let heightDialogHeader = document.getElementById('privilegegroup-dialog-header')?.offsetHeight;
            let heightDialogActionbar = document.getElementById('privilegegroup-dialog-actionbar')?.offsetHeight;
            return heightDialogHeader + heightDialogActionbar ? heightDialogHeader + heightDialogActionbar : 124;
        }
    },
    mounted: function () {
        EaseEventBus.listen('privilegegroupAdd', () => {
            this.id = null;
            this.show();
            this.load();
        });

        EaseEventBus.listen('privilegegroupEdit', params => {
            this.id = params.id;
            this.show();
            this.load(params.id);
        });
    }
}
</script>

<template>
    <dialog-base
        :maxWidth="600"
        persistent
        @close="handleClose"
        :showDialog="showDialog"
    >
        <dialog-header
            id="privilegegroup-dialog-header"
            @close="handleClose"
            :title="id ? translations.editPrivilegegroup : translations.addPrivilegegroup"
        />
        <loading :loading="processing"/>
        <dialog-body class="d-flex flex-column overflow-hidden"  :style="'max-height: calc(90vh - ' + calculateTitleAndButtonHeight() + 'px);'">
            <div class="d-flex flex-column align-center justify-center overflow-hidden">
                <text-field class="pa-4 pb-0"
                    :label="translations.name"
                    :value="name"
                    :placeholder="translations.placeholder"
                    :rules="stringRule"
                    :error="invalid"
                    autofocus
                    @input="handleChange"
                />
                <div class="w-100 pa-4 pt-4 d-flex flex-column overflow-y-auto">
                    <property-table
                        :items="privilegegroupItems"
                        :propertyName="translations.privilegeName"
                        @input="handleChangePrivilege"
                        disableSelectAll
                    />
                </div>
            </div>
        </dialog-body>
        <dialog-actionbar
            id="privilegegroup-dialog-actionbar"
            :disableSave="invalid"
            @close="handleClose"
            @save="handleSave"
        />
    </dialog-base>
</template>

<style scoped>

</style>
